import { courseGallery } from "../../data/specialTour";
import { ContentBand, Inner, KakaoButton, PageIntro, SectionHeader, SpecialTourLayout } from "./SpecialTourLayout";

export function CoursesPage() {
  return (
    <SpecialTourLayout>
      <PageIntro
        eyebrow="Courses"
        title="지역별 골프장 이미지를 한눈에 봅니다"
        body="코스 분위기와 이동 동선을 함께 보면서 팀에게 맞는 지역을 고를 수 있도록 대표 이미지를 정리했습니다."
        image="/special-tour-assets/shikoku-okudogo-gc.jpg"
      />
      <ContentBand className="bg-white">
        <Inner>
          <SectionHeader title="골프장 갤러리" body="홋카이도, 간사이, 시코쿠, 오키나와, 가고시마의 대표 코스 이미지를 모았습니다." />
          <div className="grid gap-6 md:grid-cols-2">
            {courseGallery.map((item) => (
              <article key={item.title} className="overflow-hidden rounded-lg border border-[#dce3d8] bg-[#fbfaf6] shadow-sm">
                <img src={item.image} alt={item.imageAlt} className="h-80 w-full object-cover" />
                <div className="p-6">
                  <div className="text-sm font-900 text-[#d16339]">{item.region}</div>
                  <h2 className="mt-2 text-2xl font-900 text-[#15391f]">{item.title}</h2>
                  <p className="mt-3 text-sm leading-7 text-[#596559]">{item.description}</p>
                </div>
              </article>
            ))}
          </div>
        </Inner>
      </ContentBand>
      <ContentBand>
        <Inner>
          <div className="rounded-lg border border-[#dce3d8] bg-white p-6 shadow-sm md:p-8">
            <h2 className="text-3xl font-900 text-[#15391f]">원하는 코스가 있다면 알려주세요</h2>
            <p className="mt-4 max-w-3xl text-base leading-8 text-[#596559]">
              이미 정해둔 골프장이 있어도 괜찮습니다. 항공, 숙소, 이동 시간에 맞춰 가능한 조합을 다시 계산해
              드립니다.
            </p>
            <div className="mt-6">
              <KakaoButton label="골프장 상담하기" />
            </div>
          </div>
        </Inner>
      </ContentBand>
    </SpecialTourLayout>
  );
}
